import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted } from "vue";
// config
import { config } from "@/config/config";
import { getWidowSize, resetWidowHeight, scrollToTop } from "@/utils";
// components
import {
  AppBar,
  HeaderMenu,
  BannerWithText,
  CardTitleText,
  CardImageText,
  Footer,
  ListCardGames,
} from "@/components";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const menuFixed = ref(false);
const isMobile = ref(false);
const language = config.pages.home;

const checkScroll = () => {
  if (window.pageYOffset >= 80) {
    menuFixed.value = true;
  } else {
    menuFixed.value = false;
  }
};

const checkWidowSize = () => {
  const size = getWidowSize();
  if (size?.width) {
    if (size?.width <= config.body.mobile_size) {
      isMobile.value = true;
    } else {
      resetWidowHeight();
      isMobile.value = false;
    }
  }
};

onMounted(async () => {
  checkWidowSize();
  scrollToTop();
  window.addEventListener("resize", () => {
    checkWidowSize();
  });
  document.addEventListener("scroll", () => {
    checkScroll();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    (_unref(config).header_menu.active && !isMobile.value)
      ? (_openBlock(), _createBlock(_unref(HeaderMenu), {
          key: 0,
          fixed: menuFixed.value,
          logo: _unref(config).header_menu.logo.path,
          "logo-local": _unref(config).header_menu.logo.local,
          "base-url": _unref(config).header_menu.base_url,
          background: _unref(config).header_menu.background,
          padding: _unref(config).body.padding,
          height: menuFixed.value ? _unref(config).float_menu.height : _unref(config).header_menu.height,
          menu: _unref(config).header_menu.items,
          "menu-color": _unref(config).header_menu.color,
          "menu-color-hover": _unref(config).header_menu.color_hover,
          "menu-font": _unref(config).header_menu.font,
          "menu-font-uppercase": _unref(config).header_menu.font_uppercase,
          social: _unref(config).social_media.items,
          "social-color": _unref(config).social_media.social_color,
          "social-color-hover": _unref(config).social_media.social_color_hover,
          languages: _unref(config).language.locales,
          "language-default": _unref(config).language.default
        }, null, 8, ["fixed", "logo", "logo-local", "base-url", "background", "padding", "height", "menu", "menu-color", "menu-color-hover", "menu-font", "menu-font-uppercase", "social", "social-color", "social-color-hover", "languages", "language-default"]))
      : _createCommentVNode("", true),
    (_unref(config).header_menu.active && isMobile.value)
      ? (_openBlock(), _createBlock(_unref(AppBar), {
          key: 1,
          fixed: menuFixed.value,
          logo: _unref(config).header_menu.logo.path,
          "logo-local": _unref(config).header_menu.logo.local,
          "base-url": _unref(config).header_menu.base_url,
          background: _unref(config).header_menu.background,
          padding: _unref(config).body.padding,
          height: menuFixed.value ? _unref(config).float_menu.height : _unref(config).header_menu.height,
          menu: _unref(config).header_menu.items,
          "menu-color": _unref(config).header_menu.color,
          "menu-color-hover": _unref(config).header_menu.color_hover,
          "menu-font": _unref(config).header_menu.font,
          "menu-font-uppercase": _unref(config).header_menu.font_uppercase,
          social: _unref(config).social_media.items,
          "social-color": _unref(config).social_media.social_color,
          "social-color-hover": _unref(config).social_media.social_color_hover,
          languages: _unref(config).language.locales,
          "language-default": _unref(config).language.default
        }, null, 8, ["fixed", "logo", "logo-local", "base-url", "background", "padding", "height", "menu", "menu-color", "menu-color-hover", "menu-font", "menu-font-uppercase", "social", "social-color", "social-color-hover", "languages", "language-default"]))
      : _createCommentVNode("", true),
    (_unref(language).banner.active)
      ? (_openBlock(), _createBlock(_unref(BannerWithText), {
          key: 2,
          "background-image": _unref(language).banner.backgroundImage,
          height: _unref(language).banner.height,
          logo: _unref(language).banner.logo,
          title: _unref(language).banner.title,
          subtitle: _unref(language).banner.subtitle,
          "text-position": _unref(language).banner.textPosition,
          style: _normalizeStyle({
        'margin-top': !menuFixed.value ? 0 : _unref(config).header_menu.height,
      })
        }, null, 8, ["background-image", "height", "logo", "title", "subtitle", "text-position", "style"]))
      : _createCommentVNode("", true),
    (_unref(language).feature_games.active)
      ? (_openBlock(), _createBlock(_unref(CardTitleText), {
          key: 3,
          invert: true,
          title: _unref(language).feature_games.title,
          resume: _unref(language).feature_games.resume,
          font: _unref(language).feature_games.font,
          "font-size": _unref(language).feature_games.font_size,
          center: _unref(language).feature_games.center,
          "padding-block": _unref(language).feature_games.padding_block,
          "padding-inline": _unref(config).body.padding
        }, null, 8, ["title", "resume", "font", "font-size", "center", "padding-block", "padding-inline"]))
      : _createCommentVNode("", true),
    (_unref(language).games.active)
      ? (_openBlock(), _createBlock(_unref(ListCardGames), {
          key: 4,
          items: _unref(language).games.items,
          gap: _unref(language).games.gap,
          background: _unref(language).games.background,
          "padding-block": _unref(language).games.padding_block,
          "padding-inline": _unref(config).body.padding
        }, null, 8, ["items", "gap", "background", "padding-block", "padding-inline"]))
      : _createCommentVNode("", true),
    (_unref(language).company_about.active)
      ? (_openBlock(), _createBlock(_unref(CardImageText), {
          key: 5,
          center: _unref(language).company_about.center,
          image: _unref(language).company_about.image.path,
          "image-local": _unref(language).company_about.image.local,
          "image-width": _unref(language).company_about.image.width,
          text: _unref(language).company_about.resume.text,
          "long-text": _unref(language).company_about.resume.long_text,
          "padding-block": _unref(language).company_about.padding_block,
          "padding-inline": _unref(config).body.padding
        }, null, 8, ["center", "image", "image-local", "image-width", "text", "long-text", "padding-block", "padding-inline"]))
      : _createCommentVNode("", true),
    (_unref(config).footer.active)
      ? (_openBlock(), _createBlock(_unref(Footer), {
          key: 6,
          logo: _unref(config).footer.logo,
          "logo-local": _unref(config).footer.logo_is_local,
          resume: _unref(config).footer.resume,
          padding: _unref(config).body.padding,
          background: _unref(config).footer.background,
          font: _unref(config).footer.font,
          "font-color": _unref(config).footer.font_color,
          "menu-color": _unref(config).footer.menu.color,
          menu: _unref(config).footer.menu.items,
          "menu-color-hover": _unref(config).footer.menu.color_hover,
          "menu-font": _unref(config).footer.menu.font,
          "menu-font-uppercase": _unref(config).footer.menu.font_uppercase,
          social: _unref(config).social_media.items,
          "social-color": _unref(config).social_media.social_color,
          "social-color-hover": _unref(config).social_media.social_color_hover,
          "copyright-year": _unref(config).footer.copyright.year,
          "copyright-resume": _unref(config).footer.copyright.resume,
          "copyright-background": _unref(config).footer.copyright.background,
          "copyright-uppercase": _unref(config).footer.copyright.font_uppercase
        }, null, 8, ["logo", "logo-local", "resume", "padding", "background", "font", "font-color", "menu-color", "menu", "menu-color-hover", "menu-font", "menu-font-uppercase", "social", "social-color", "social-color-hover", "copyright-year", "copyright-resume", "copyright-background", "copyright-uppercase"]))
      : _createCommentVNode("", true)
  ]))
}
}

})